import { Box, makeStyles, Avatar, Button } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    background: '#FFFFFF',
    height: '100%',
    backgroundImage: `url('/static/backgroundApp.svg')`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center'
  },
  wrapper: {
    maxWidth: 968,
    margin: '0 auto'
  },
  btnDownload: {
    minWidth: '200px',
    background: '#E5E6EB',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textTransform: 'none',
    padding: '10px 0px',
    color: '#0C1132',
    fontSize: '14px',
    fontWeight: '600',

    '&:hover': {
      color: '#EE0434'
    }
  }
}));

const AppDownload = () => {
  const classes = useStyles();
  return (
    <>
      <Box className={classes.root}>
        <Box
          className={classes.wrapper}
          style={{
            height: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'flex-end', // đẩy nội dung xuống cuối
            paddingBottom: '100px' // khoảng cách với bottom
          }}
        >
          <Box
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '20px',
              alignItems: 'center'
            }}
          >
            <Button
              className={classes.btnDownload}
              href="https://play.google.com/store/apps/details?id=com.vntech24h.vcarsmobile"
            >
              <Box
                style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
              >
                <Box style={{ width: '22px', height: '25px' }}>
                  <img
                    src={'/static/iconSvg/android.svg'}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover'
                    }}
                  />
                </Box>
                <span style={{ lineHeight: '25px' }}>Android Download</span>
              </Box>
            </Button>

            <Button
              className={classes.btnDownload}
              href="https://apps.apple.com/vn/app/vgps/id1584121002?l=vi"
            >
              <Box
                style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
              >
                <span style={{ width: '20px', height: '25px' }}>
                  <img
                    src={'/static/iconSvg/apple.svg'}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover'
                    }}
                  />
                </span>
                <span style={{ lineHeight: '25px' }}>IOS Download</span>
              </Box>
            </Button>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default AppDownload;
